export default __webpack_public_path__ + "static/media/banner-products.a1c9b4dd.png";